import styled from "styled-components";

export const Container = styled.div`
	@media screen and (min-width: 0px) {
		min-height: calc(100vh - 90px);
		flex: 1 1 auto;
		max-height: 100%;
		display: flex;
		flex-direction: column;

		section {
			flex: 1 1 auto;
			background-color: var(--primary-color);
			padding: 0 1em;

			h2 {
				color: var(--white);
				text-transform: uppercase;
				font-size: 0.875em;
			}

			.cupons {
				padding: 0;
				margin: 0;
				display: flex;
				flex-direction: column;
				row-gap: 1em;

				li {
					background-color: var(--white);
					padding: 1em;
					border-radius: 8px;
					display: flex;
					flex-direction: column;
					box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.1);
					margin: 5px 0;

					p {
						margin: 2px 0;
					}

					header {
						display: flex;
						justify-content: space-between;
						margin: 0;

						.cupomSerie {
							font-size: 1em;
							font-weight: bold;
						}

						.cupomDate {
							font-size: 0.875em;
							font-weight: bold;
						}
					}

					.cupomInfo {
						p {
							font-size: 1em;
						}
					}
				}
			}

			header {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 15px;
				margin-top: 15px;

				#btn-nft-enable {
					display: block;
					text-decoration: none;
					text-align: center;
					font-size: 1em;
					text-transform: uppercase;
					padding: 1em;
					max-width: 299px;
					border: 1px solid var(--primary-color);
					transition: all 0.3s;
					background-color: var(--white);
					color: var(--primary-color);
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		flex-direction: row;
		height: calc(100vh - 45px);

		aside {
			flex-basis: 50%;
			display: flex;
			flex-direction: column;
			align-items: center;
			background-color: var(--grey-color);

			img {
				max-height: 100%;
			}
		}

		section {
			flex-basis: 50%;
			overflow-y: auto;
			/* background-image: url(${require("../../../assets/img/labyes.png")
		.default});
			background-repeat: no-repeat;
			background-position: right bottom; */
			padding: 0 2em;
			padding-top: 1em;

			.cupons {
				max-height: 70vh;
				overflow-y: auto;
			}

			h2 {
				margin-bottom: 2em;
			}
		}
	}
`;
